module.exports = "<mdl-table mdl-shadow=\"2\"\n  [table-model]=\"tableModel\">\n</mdl-table>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/misc-components/shared-table-template.html
 ** module id = 214
 ** module chunks = 0
 **/